import React from 'react';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
export function PostLaunchTruth() {
  return <section className="py-16 md:py-20 bg-paper-dark border-y border-gray-200 relative" data-id="element-460" data-mp="2zzjl132yt165">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-461" data-mp="3dz2fwu6rmg0i">
        <PathThread data-id="element-462" data-mp="39wnxgb70di9r" />
      </div>
      <div className="max-w-2xl mx-auto px-6 text-center" data-id="element-463" data-mp="39vcsi81tu4h2">
        <Reveal data-id="element-464" data-mp="3nw738xcckhiw">
          <h2 className="text-2xl md:text-4xl font-serif text-navy mb-10 leading-tight" data-id="element-465" data-mp="3nvnkjeevhp3t">
            The book can look successful{' '}
            <span className="italic text-seaglass" data-id="element-466" data-mp="3iwkscujzrdd9">
              and still feel underused
            </span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-467" data-mp="3smx9ecslkoen">
          <div className="text-lg text-text-muted leading-relaxed space-y-5 mb-14" data-id="element-468" data-mp="3smnjsqbgsj9h">
            <p data-id="element-469" data-mp="agrb2dhu5xv5">A serious nonfiction book is not a small thing.</p>
            <p data-id="element-470" data-mp="af7vyq7x1suy">
              It carries your thinking, stories, frameworks, language, point of
              view, and years of work most people never see.
            </p>
            <p data-id="element-471" data-mp="2wbspcvnc4vfd">So the problem is not that the book failed.</p>
            <p data-id="element-472" data-mp="318swzazu268l">
              The book may have done its first job. It created credibility. It
              gave people a reason to trust you.
            </p>
            <p data-id="element-473" data-mp="36aiaqyefwy0d">But credibility alone does not tell a reader what to do next.</p>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-474" data-mp="3b55qo8vdok3c">
          <div className="relative" data-id="element-475" data-mp="3f9n3tp78fz55">
            <div className="w-10 h-0.5 bg-sand rounded-full mx-auto mb-7" data-id="element-476" data-mp="3f8kdpjhqi0qa"></div>
            <p className="text-2xl md:text-3xl font-serif text-navy leading-snug" data-id="element-477" data-mp="3k758h3e7vs7c">
              "The book may have worked. <br className="hidden md:block" data-id="element-478" data-mp="3ozf49020jmhj" />
              <span className="italic text-seaglass" data-id="element-479" data-mp="3txqdp9oebuz8">
                The path after it may be what was missing.
              </span>
              "
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}